import { jsxs as c, jsx as l } from "react/jsx-runtime";
const h = (i) => /* @__PURE__ */ c(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25",
    ...i,
    children: [
      /* @__PURE__ */ l("g", { clipPath: "url(#shopify-colored_svg__a)", children: /* @__PURE__ */ c("g", { clipPath: "url(#shopify-colored_svg__b)", children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#95BF46",
            d: "M19.394 5.564a.23.23 0 0 0-.209-.194l-1.922-.143L15.85 3.82c-.14-.14-.414-.097-.52-.066l-.713.22c-.426-1.225-1.177-2.35-2.499-2.35q-.054 0-.112.003c-.376-.497-.841-.713-1.243-.713-3.08 0-4.55 3.85-5.012 5.805l-2.155.669c-.668.21-.69.23-.777.86-.066.476-1.814 13.991-1.814 13.991l13.618 2.551L22 23.195S19.41 5.684 19.394 5.564m-5.53-1.356-1.153.357.001-.249c0-.761-.106-1.374-.275-1.86.681.085 1.135.86 1.427 1.752m-2.272-1.601c.19.474.312 1.155.312 2.074v.134l-2.38.737c.458-1.769 1.317-2.623 2.068-2.945m-.915-.866q.201 0 .395.133c-.987.464-2.045 1.634-2.491 3.97l-1.882.582c.524-1.781 1.766-4.685 3.978-4.685"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#5E8E3E",
            d: "m19.185 5.37-1.922-.143-1.415-1.405a.35.35 0 0 0-.196-.09l-1.03 21.06L22 23.194 19.393 5.564a.23.23 0 0 0-.208-.194"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#fff",
            d: "m12.117 9.447-.91 2.706s-.797-.426-1.774-.426c-1.433 0-1.505.9-1.505 1.126 0 1.236 3.222 1.71 3.222 4.605 0 2.277-1.444 3.744-3.392 3.744-2.338 0-3.533-1.455-3.533-1.455l.626-2.068s1.228 1.055 2.265 1.055c.678 0 .953-.533.953-.923 0-1.612-2.643-1.684-2.643-4.333 0-2.23 1.6-4.388 4.831-4.388 1.245 0 1.86.357 1.86.357"
          }
        )
      ] }) }),
      /* @__PURE__ */ c("defs", { children: [
        /* @__PURE__ */ l("clipPath", { id: "shopify-colored_svg__a", children: /* @__PURE__ */ l("path", { fill: "#fff", d: "M0 .85h24v24H0z" }) }),
        /* @__PURE__ */ l("clipPath", { id: "shopify-colored_svg__b", children: /* @__PURE__ */ l("path", { fill: "#fff", d: "M1 .85h21.043v24H1z" }) })
      ] })
    ]
  }
);
export {
  h as default
};
